/**
 * Generated by orval v8.14.0 🍺
 * Do not edit manually.
 * Realico Portal API
 * Portal API
 * OpenAPI spec version: 1.0.0
 */

/**
 * @nullable
 */
export type ListingDetailResponseDtoLandReadiness = typeof ListingDetailResponseDtoLandReadiness[keyof typeof ListingDetailResponseDtoLandReadiness] | null;


export const ListingDetailResponseDtoLandReadiness = {
  WITH_UTILITIES: 'WITH_UTILITIES',
  WITHOUT_UTILITIES: 'WITHOUT_UTILITIES',
  PARTIAL: 'PARTIAL',
} as const;
